import { Component, Input, OnInit } from '@angular/core';
import { AbstractControl, FormControl, FormGroup } from '@angular/forms';
import { ValidationErrorHandler } from '@app/shared/components/validation-errors/validation-error-handler';
import { ID } from '@app/utils/common';
import { RequiredFormValue } from '@app/utils/forms';
import { FormGroupTyped } from '../../../../types/typed-forms';

interface LifecycleFields {
  deprecated: FormControl<boolean>;
  preview: FormControl<boolean>;
}

@Component({
  selector: 'portal-lifecycle-flag-switcher',
  templateUrl: './lifecycle-flag-switcher.component.html',
  styles: [],
  standalone: false,
})
export class LifecycleFlagSwitcherComponent implements OnInit {
  @Input()
  form!: FormGroup<LifecycleFields> | FormGroupTyped<RequiredFormValue<LifecycleFields>>;

  id = ID();

  get deprecated(): AbstractControl<boolean> {
    return this.form.controls.deprecated;
  }

  get preview(): AbstractControl<boolean> {
    return this.form.controls.preview;
  }

  constructor() {}

  ngOnInit(): void {
    this.form.addValidators((control: FormGroup<LifecycleFields>) =>
      ValidationErrorHandler.validate({
        i18nKey: 'downloads.lifecycleInvalid.html',
        key: 'lifecycleInvalid',
        invalid: control.value?.deprecated === true && control.value?.preview === true,
      })
    );
  }

  setDeprecated(): void {
    if (this.preview.value === true) {
      this.deprecated.setValue(!this.preview.value);
      this.deprecated.updateValueAndValidity();
    }
  }

  setPreview(): void {
    if (this.deprecated.value === true) {
      this.preview.setValue(false);
      this.preview.updateValueAndValidity();
    }
  }
}
